import { useState } from "react";

function ProceduresTab() {
  const [selectedProcedure, setSelectedProcedure] = useState(null);

  // Sample procedures data
  const procedures = [
    {
      id: 1,
      name: "Customer Due Diligence (CDD) Procedure",
      category: "Onboarding",
      version: "1.0",
      lastUpdated: "2025-09-15",
      status: "Active",
      description: "Standard procedures for customer identification and verification during onboarding process."
    },
    {
      id: 2,
      name: "Enhanced Due Diligence (EDD) Procedure",
      category: "High Risk",
      version: "1.0",
      lastUpdated: "2025-09-15",
      status: "Active",
      description: "Additional verification steps for high-risk customers, PEPs, and high-value transactions."
    },
    {
      id: 3,
      name: "Sanctions & PEP Screening Procedure",
      category: "Compliance",
      version: "1.0",
      lastUpdated: "2025-09-15",
      status: "Active",
      description: "Daily screening process against UAE, UN, OFAC, and EU sanctions lists."
    },
    {
      id: 4,
      name: "Suspicious Transaction Reporting (STR) Procedure",
      category: "Reporting",
      version: "1.0",
      lastUpdated: "2025-09-15",
      status: "Active",
      description: "Step-by-step process for identifying, escalating, and filing STRs via goAML platform."
    },
    {
      id: 5,
      name: "Record Keeping & Retention Procedure",
      category: "Data Management",
      version: "1.0",
      lastUpdated: "2025-09-15",
      status: "Active",
      description: "Guidelines for maintaining customer records, transaction data, and audit trails for 5 years."
    }
  ];

  const handleViewProcedure = (procedure) => {
    setSelectedProcedure(procedure);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>AML Procedures</h2>
      
      <p style={{ color: "#555", marginBottom: 30, fontSize: 15 }}>
        Standard Operating Procedures (SOPs) for AML compliance operations aligned with FATF recommendations and UAE AML regulations.
      </p>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          background: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#0d47a1", color: "white" }}>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>
              Procedure Name
            </th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>
              Category
            </th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>
              Version
            </th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>
              Last Updated
            </th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>
              Status
            </th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {procedures.map((procedure) => (
            <tr key={procedure.id}>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>
                {procedure.name}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>
                {procedure.category}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>
                {procedure.version}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>
                {procedure.lastUpdated}
              </td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>
                <span
                  style={{
                    backgroundColor: "#4caf50",
                    color: "white",
                    padding: "4px 12px",
                    borderRadius: "12px",
                    fontSize: "13px",
                  }}
                >
                  {procedure.status}
                </span>
              </td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>
                <button
                  onClick={() => handleViewProcedure(procedure)}
                  style={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    marginRight: "5px",
                  }}
                >
                  View Procedure
                </button>
                <button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => alert("Download feature coming soon")}
                >
                  Download
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Procedure Detail Modal */}
      {selectedProcedure && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              width: "70%",
              maxHeight: "80vh",
              overflow: "auto",
              position: "relative",
            }}
          >
            <button
              onClick={() => setSelectedProcedure(null)}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Close
            </button>

            <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>
              {selectedProcedure.name}
            </h2>

            <div style={{ marginBottom: 20 }}>
              <p><strong>Category:</strong> {selectedProcedure.category}</p>
              <p><strong>Version:</strong> {selectedProcedure.version}</p>
              <p><strong>Last Updated:</strong> {selectedProcedure.lastUpdated}</p>
              <p><strong>Status:</strong> {selectedProcedure.status}</p>
            </div>

            <hr style={{ margin: "20px 0" }} />

            <h3 style={{ color: "#0d47a1", marginBottom: 15 }}>Procedure Description</h3>
            <p style={{ lineHeight: 1.6, color: "#555" }}>
              {selectedProcedure.description}
            </p>

            <h3 style={{ color: "#0d47a1", marginTop: 30, marginBottom: 15 }}>
              Key Steps
            </h3>
            <ol style={{ lineHeight: 1.8, color: "#555" }}>
              <li>Review and verify customer documentation against requirements</li>
              <li>Conduct risk assessment based on customer profile and transaction patterns</li>
              <li>Screen customer against sanctions lists and PEP databases</li>
              <li>Document findings and obtain necessary approvals</li>
              <li>Update customer records in the system with audit trail</li>
              <li>Schedule periodic review dates based on risk classification</li>
            </ol>

            <h3 style={{ color: "#0d47a1", marginTop: 30, marginBottom: 15 }}>
              Regulatory References
            </h3>
            <ul style={{ lineHeight: 1.8, color: "#555" }}>
              <li>FATF Recommendation 10 - Customer Due Diligence</li>
              <li>UAE AML Law (Federal Decree-Law No. 20 of 2018)</li>
              <li>CBUAE AML Rulebook - Article 4</li>
              <li>Cabinet Decision No. 10 of 2019</li>
            </ul>

            <div
              style={{
                marginTop: 30,
                padding: 15,
                backgroundColor: "#fff3cd",
                borderLeft: "4px solid #ff9800",
                borderRadius: 5,
              }}
            >
              <strong>Note:</strong> This is a sample procedure for POC demonstration purposes. 
              Full detailed procedures will be developed in the next phase.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProceduresTab;